// Componente para exibir cards de plots em carrossel
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Navigation,
  Pagination,
  Scrollbar,
  Autoplay,
  FreeMode,
} from "swiper/modules";
import Card from "./card/card";

/**
 * Componente CardsSection - Seção de cards em carrossel
 */
const CardsSection = ({ plots, plagueSelected }) => {
  // Filtrar plots baseado na praga selecionada e probabilidade mínima
  const filteredPlots = plots.filter((plot) => {
    const matchesPlague = plagueSelected === "" || plot.plague === plagueSelected;
    const hasMinProbability = plot.prob >= 15;
    return matchesPlague && hasMinProbability;
  });

  if (filteredPlots.length === 0) {
    return null;
  }

  return (
    <Swiper
      modules={[Navigation, Pagination, Scrollbar, Autoplay, FreeMode]}
      style={{ width: "90%", marginBottom: "25px" }}
      pagination={{
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 10,
      }}
      slidesPerView={1}
      autoplay={{
        delay: 3000,
      }}
      freeMode={true}
    >
      {filteredPlots.map((plot, index) => (
        <SwiperSlide key={index}>
          <Card plot={plot} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default CardsSection;

